import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { Observable, throwError } from "rxjs";
import { BBResponseContainer } from "../common-services/response-container";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map, timeout } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CustomerTrackService {

  readonly SENDERMDMSERVICE = 'admin/mdm/sender';

  constructor(private http: HttpClient) { }

  getMapOfSenders(labId: string, active: boolean): Observable<BBResponseContainer> {

    let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE + "/mapOfSenders";
    let requestParam = new HttpParams().set('labId', labId).set('active', active.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getBatches(labId: string, filterObject: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/tracking/list";
    let requestParam = new HttpParams().set('lab', labId).set('requestParam', filterObject);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  exportExcelExportForBatchData(jsonString: any) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + '/covid19Batch/tracking/exportExcel' ;
    return this.http.put(url, jsonString, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }),catchError(error => throwError(error.message))
    );
  }
}
